module.exports = require("@makemydeal/dr-platform-shared");